import type { AgendaDto } from "@/repositories/agendaRepo";
import React, { createContext, useContext } from "react";

export const AgendaDefaultsContext = createContext<Partial<AgendaDto> | null>(
  null
);

export const AgendaDefaults = ({
  defaults,
  children,
}: {
  defaults: Partial<AgendaDto>;
  children?: React.ReactNode;
}) => {
  const prevDefaults = useContext(AgendaDefaultsContext);
  const nextDefaults = { ...prevDefaults, ...defaults };

  return (
    <AgendaDefaultsContext.Provider value={nextDefaults}>
      {children}
    </AgendaDefaultsContext.Provider>
  );
};
